<template lang="pug">
    div
        .form__title
            slot(name='title')
        form.form__body(action='javascript://' v-if='params')
            //slot(name='multiplayer')
            template(v-if='!homework || homework.editable === undefined || (homework && (homework.editable || usersIds))')
                .form__field
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_positionOfUndefined') }}
                    .form__field-body
                        cs-multiselect(
                            :multiple="false"
                            :options="positions"
                            :show-labels="false"
                            :allow-empty="false"
                            track-by="name"
                            label="label"
                            :placeholder="$i18n.t('trainer.trainer_gameFormSetting_choosePosition')"
                            v-model="selectedPosition"
                            @select="positionsHandler"
                        )
                .form__field(v-if="gameMode !== 'course'")
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
                    .form__field-body
                        cs-spin-input(
                            :value="params.amountOfExamples",
                            :max="amountOfExamples",
                            :min="1",
                            :disabled="!!params.timeLimit",
                            @increase="increaseExamples",
                            @decrease="decreaseExamples",
                            @input="params.amountOfExamples = $event",
                        )
                .form__field
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfActions') }}
                    .form__field-body
                        cs-spin-input(
                            :value="params.amountOfActions",
                            :max="amountOfActions",
                            :min="2",
                            @increase="increaseActions",
                            @decrease="decreaseActions",
                            @input="params.amountOfActions = $event",
                        )
                .form__field(v-if="selectedPosition.name !== 'inAnswer'")
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_numOfUnknowns') }}
                    .form__field-body
                        cs-spin-input(
                            :value="params.amountOfUnknowns",
                            :max="availableAmountOfUnknowns",
                            :min="1",
                            @increase="increaseUnknowns"
                            @decrease="decreaseUnknowns",
                            @input="params.amountOfUnknowns = $event",
                        )
                .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_timeLimit') }}
                    .form__field-body
                        cs-multiselect(
                            :options="timeLimitValues",
                            v-model="params.timeLimit"
                            :placeholder="timeLimitLabel(params.timeLimit)"
                            :multiple="false"
                            :custom-label="timeLimitLabel",
                            :allow-empty="false"
                        )
                .form__field
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_stayIn', {x: 5}) }}
                    .form__field-body
                        cs-checkbox(
                            :checked="params.stayIn5"
                            @change="handleClickOnSettingsCheckbox('stayIn5')"
                            :disabled="params.stayIn5"
                        )
                .form__field
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_stayIn', {x: 10}) }}
                    .form__field-body
                        cs-checkbox(
                            :checked="params.stayIn10"
                            @change="handleClickOnSettingsCheckbox('stayIn10')"
                            :disabled="params.stayIn10"
                        )
                .form__field
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_stayIn', {x: 20}) }}
                    .form__field-body
                        cs-checkbox(
                            :checked="params.stayIn20"
                            @change="handleClickOnSettingsCheckbox('stayIn20')"
                            :disabled="params.stayIn20"
                        )
                .form__field
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_stayIn', {x: 100}) }}
                    .form__field-body
                        cs-checkbox(
                            :checked="params.stayIn100"
                            @change="handleClickOnSettingsCheckbox('stayIn100')"
                            :disabled="params.stayIn100"
                        )
                .form__field(v-if='isJumpAllow')
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_withJump') }}
                    .form__field-body
                        cs-checkbox(
                            :checked="params.withJumpThroughTenners"
                            @change="handleClickOnSettingsCheckbox('withJumpThroughTenners')"
                            :disabled="!params.stayIn100"
                        )
                .form__field
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_doubleDigits') }}
                    .form__field-body
                        cs-checkbox(
                            :checked="params.doubleDigits"
                            @change="handleClickOnSettingsCheckbox('doubleDigits')"
                            :disabled="params.doubleDigits"
                        )
                .form__field
                    label.form__label
                        | + {{ $i18n.t('trainer.trainer_gameFormSetting_singleDigits') }}
                    .form__field-body
                        cs-checkbox(
                            :checked="params.plusSingleDigits"
                            @change="handleClickOnSettingsCheckbox('plusSingleDigits')"
                            :disabled="(!params.doubleDigits || params.plusSingleDigits)"
                        )
                .form__field(v-if="isJumpAllow")
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_withJump') }}
                    .form__field-body
                        cs-checkbox(
                            :checked="params.withSingleDigitsJump"
                            @change="handleClickOnSettingsCheckbox('withSingleDigitsJump')"
                            :disabled="!params.plusSingleDigits"
                        )
                .form__field
                    label.form__label
                        |  + {{ $i18n.t('trainer.trainer_gameFormSetting_roundDoubleDigits') }}
                    .form__field-body
                        cs-checkbox(
                            :checked="params.plusRoundDoubleDigits"
                            @change="handleClickOnSettingsCheckbox('plusRoundDoubleDigits')"
                            :disabled="(!params.doubleDigits || params.plusRoundDoubleDigits)"
                        )
                .form__field
                    label.form__label
                        |  {{ $i18n.t('trainer.trainer_gameFormSetting_roundDoubleDigits') }}
                    .form__field-body
                        cs-checkbox(
                            :checked="params.roundDoubleDigits"
                            @change="handleClickOnSettingsCheckbox('roundDoubleDigits')"
                            :disabled="params.roundDoubleDigits"
                        )
                .form__field
                    label.form__label
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_roundTripleDigits') }}
                    .form__field-body
                        cs-checkbox(
                            :checked="params.roundTripleDigits"
                            @change="handleClickOnSettingsCheckbox('roundTripleDigits')"
                            :disabled="params.roundTripleDigits"
                        )
            slot(name='parameters')
            slot(name='help')
            .form__buttons(v-if='!usersIds')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                template(v-if="gameMode === 'free-game'")
                    cs-button.form__button(color="blue", @click='saveGameMode')
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                template(v-else='')
                    cs-button.form__button(color="blue", @click='saveGame')
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
            .form__buttons(v-else='')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                cs-button.form__button(color="blue", @click='saveGame')
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
</template>

<script>
    import _ from 'lodash';
    import { mapState } from 'vuex';
    import TrainerGames from '../../../config/trainer';
    import GameFormMixin from '../../../utils/trainer/GameFormMixin';
    import { getInitParameters } from '../../../utils/trainer/getInitParameters';
    const DEFAULT_TIME_LIMIT = 0;
    import multiplayerFormMixin from '../../../utils/multiplayer/formMixin';
    import combiningCapacitiesMixin from '../utils/combiningCapacitiesMixin';

    import IntervalConfig from '../../trainer/configs/IntervalConfig';

    export default {
        props: [
            'slug',
            'courseType',
            'id',
            'usersIds',
            'homeworkId',
            'gameMode',
            'levelAnswerDuration',
            'gameId',
            'generatorSettings',
            'generatorGameIndex',
        ],
        data() {
            return {
                positions: [
                    {
                        label: this.$i18n.t('common.common_gameSetting_inAnswer'),
                        name: 'inAnswer',
                    },
                    {
                        label: this.$i18n.t('common.common_gameSetting_inTerm'),
                        name: 'inTerm',
                    },
                ],
                jumpSettings: [
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSetting_withJump'),
                        name: true,
                    },
                    {
                        label: this.$i18n.t('trainer.trainer_gameFormSetting_withoutJump'),
                        name: false,
                    },
                ],
                amountOfExamples: 100,
                amountOfActions: 10,
                timeLimitValues: IntervalConfig.timeLimitValues,
                params: null,
                selectedPosition: null,
            };
        },
        mixins: [GameFormMixin, multiplayerFormMixin, combiningCapacitiesMixin],
        mounted() {
            if (this.gameMode === 'free-game') {
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = _.cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else if (this.gamesParameters) {
                    this.$set(
                        this,
                        'params',
                        getInitParameters({
                            slug: this.slug,
                            parameters: {
                                default: _.cloneDeep(this.gamesParameters[this.slug]),
                            },
                        })
                    );
                } else {
                    _.cloneDeep(TrainerGames.games).forEach(item => {
                        if (item.slug === this.slug) {
                            this.params = item.parameters.default;
                        }
                    });
                }
                this.selectedPosition = _.find(this.positions, { name: this.params.position });
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
        },
        watch: {
            'params.amountOfExamples'(val) {
                if (val) {
                    this.params.timeLimit = DEFAULT_TIME_LIMIT;
                }
            },
            'params.timeLimit'(val) {
                if (val) {
                    this.params.amountOfExamples = false;
                } else {
                    if (!this.params.amountOfExamples) {
                        this.params.amountOfExamples = 1;
                    }
                }
            },
            'params.amountOfActions'(val) {
                if (this.params.amountOfUnknowns >= +val) {
                    this.params.amountOfUnknowns = +val - 1;
                }
            },
            'params.doubleDigits'(val) {
                val && !this.params.plusRoundDoubleDigits && (this.params.plusSingleDigits = true);
            },
            'params.position'(val) {
                if (val === 'inTerm') {
                    this.params.withJumpThroughTenners = false;
                    this.params.withSingleDigitsJump = false;
                }
            },
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user,
            }),
            availableAmountOfUnknowns() {
                return this.params.amountOfActions === 2 ? 1 : this.params.amountOfActions - 2;
            },
            isJumpAllow() {
                return this.params.position === 'inAnswer';
            },
        },
        methods: {
            positionsHandler(position) {
                this.params.position = position.name;
            },
            timeLimitLabel(amount) {
                return amount === 0
                    ? this.$i18n.t('trainer.trainer_gameFormSettingValue_off')
                    : amount + ' ' + this.$i18n.t('trainer.trainer_gameFormSettingValue_minutes');
            },
            handleClickOnSettingsCheckbox(checkedSetting) {
                let settings = [
                    'stayIn5',
                    'stayIn10',
                    'stayIn20',
                    'stayIn100',
                    'withJumpThroughTenners',
                    'doubleDigits',
                    'plusSingleDigits',
                    'withSingleDigitsJump',
                    'plusRoundDoubleDigits',
                    'roundDoubleDigits',
                    'roundTripleDigits',
                ];
                if (checkedSetting === 'withJumpThroughTenners') {
                    settings = settings.filter(
                        setting => setting !== 'stayIn100' && setting !== 'withJumpThroughTenners'
                    );
                    this.params[checkedSetting] = !this.params[checkedSetting];
                }
                if (checkedSetting === 'plusSingleDigits') {
                    settings = settings.filter(
                        setting =>
                            setting !== 'plusSingleDigits' &&
                            setting !== 'withSingleDigitsJump' &&
                            setting !== 'doubleDigits'
                    );
                    this.params[checkedSetting] = !this.params[checkedSetting];
                }
                if (checkedSetting === 'withSingleDigitsJump') {
                    settings = settings.filter(
                        setting =>
                            setting !== 'plusSingleDigits' &&
                            setting !== 'withSingleDigitsJump' &&
                            setting !== 'doubleDigits'
                    );
                    this.params[checkedSetting] = !this.params[checkedSetting];
                }
                if (checkedSetting === 'plusRoundDoubleDigits') {
                    settings = settings.filter(
                        setting => setting !== 'plusRoundDoubleDigits' && setting !== 'doubleDigits'
                    );
                    this.params[checkedSetting] = !this.params[checkedSetting];
                }
                settings.forEach(setting => (this.params[setting] = checkedSetting === setting));
            },
            decreaseExamples() {
                if (this.params.amountOfExamples !== 1 && !this.params.timeLimit) {
                    this.params.amountOfExamples -= 1;
                }
            },
            increaseExamples() {
                if (this.params.amountOfExamples !== this.amountOfExamples && !this.params.timeLimit) {
                    this.params.amountOfExamples += 1;
                }
            },
            decreaseActions() {
                if (this.params.amountOfActions !== 2) {
                    this.params.amountOfActions -= 1;
                }
            },
            increaseActions() {
                if (this.params.amountOfActions !== this.amountOfActions) {
                    this.params.amountOfActions += 1;
                }
            },
            decreaseUnknowns() {
                if (this.params.amountOfUnknowns !== 1) {
                    this.params.amountOfUnknowns -= 1;
                }
            },
            increaseUnknowns() {
                if (this.params.amountOfUnknowns !== this.availableAmountOfUnknowns) {
                    this.params.amountOfUnknowns += 1;
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }
    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: 0.5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }
    .form__field-body {
        flex-grow: 5;
    }

    .form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px;
        @include media($md) {
            margin: 0 10px;
        }
    }
</style>
